import { Theme } from './types';

// Design system 3.0: https://www.figma.com/file/8tfClE5hVeWthoVwCuFdam/Design-system-3.0?type=design&node-id=1%3A712&t=wM0RidFpLs6gxXTQ-1

export const definitions: Theme = {
	radius: {
		small: '4px',
		medium: '8px',
		large: '12px',
		circle: '50%',
	},
	colorLight: {
		white: '0, 0%, 100%',
		black: '0, 0%, 0%',
		// Gray - Shades of gray
		'gray-50': '220, 7%, 92%',
		'gray-100': '214, 9%, 84%',
		'gray-200': '220, 7%, 76%',
		'gray-300': '220, 8%, 69%',
		'gray-400': '220, 7%, 60%',
		'gray-500': '218, 8%, 52%',
		'gray-600': '218, 10%, 44%',
		'gray-700': '220, 13%, 36%',
		'gray-800': '219, 19%, 29%',
		'gray-900': '219, 30%, 21%',
		// Light gray - Shades of light gray
		'light-gray-50': '210, 17%, 98%',
		'light-gray-100': '195, 17%, 95%',
		'light-gray-200': '201, 15%, 82%',
		'light-gray-300': '200, 15%, 72%',
		'light-gray-400': '199, 15%, 63%',
		'light-gray-500': '200, 15%, 54%',
		'light-gray-600': '200, 13%, 48%',
		'light-gray-700': '199, 13%, 43%',
		'light-gray-800': '199, 13%, 37%',
		'light-gray-900': '200, 13%, 32%',
		// Blue / Primary - Primary blue (500) and other shodes
		'blue-50': '213, 85%, 97%',
		'blue-100': '211, 84%, 95%',
		'blue-200': '211, 88%, 81%',
		'blue-300': '211, 88%, 72%',
		'blue-400': '211, 88%, 62%',
		'blue-500': '211, 88%, 53%',
		'blue-600': '211, 78%, 47%',
		'blue-700': '211, 78%, 42%',
		'blue-800': '211, 79%, 37%',
		'blue-900': '211, 78%, 32%',
		// Green / Success - Shades of green, used mostly for success
		'green-50': '160, 60%, 97%',
		'green-100': '160, 64%, 95%',
		'green-200': '161, 67%, 78%',
		'green-300': '161, 67%, 68%',
		'green-400': '161, 67%, 57%',
		'green-500': '161, 79%, 46%',
		'green-600': '160, 79%, 41%',
		'green-700': '161, 79%, 37%',
		'green-800': '161, 79%, 32%',
		'green-900': '161, 79%, 28%',
		// Purple - Shades of purple, used mostly for instalments
		'purple-50': '240, 33%, 98%',
		'purple-100': '233, 39%, 95%',
		'purple-200': '234, 41%, 82%',
		'purple-300': '233, 40%, 73%',
		'purple-400': '234, 41%, 64%',
		'purple-500': '234, 41%, 56%',
		'purple-600': '234, 33%, 50%',
		'purple-700': '234, 33%, 44%',
		'purple-800': '234, 32%, 39%',
		'purple-900': '233, 33%, 33%',
		// Orange / Warning - Shades of orange, used mostly for warnings and investments
		'orange-50': '32, 100%, 97%',
		'orange-100': '34, 100%, 95%',
		'orange-200': '34, 100%, 81%',
		'orange-300': '34, 100%, 71%',
		'orange-400': '34, 100%, 62%',
		'orange-500': '34, 100%, 52%',
		'orange-600': '34, 92%, 42%',
		'orange-700': '34, 92%, 31%',
		'orange-800': '34, 92%, 21%',
		'orange-900': '33, 92%, 10%',
		// Red / Error - Shades of red, used mostly for errors, destructive actions and really important highlights.
		'red-50': '0, 82%, 98%',
		'red-100': '357, 82%, 96%',
		'red-200': '358, 86%, 83%',
		'red-300': '357, 88%, 75%',
		'red-400': '357, 87%, 66%',
		'red-500': '357, 88%, 58%',
		'red-600': '357, 63%, 46%',
		'red-700': '357, 63%, 35%',
		'red-800': '358, 63%, 23%',
		'red-900': '358, 63%, 12%',
		// Design system (ds) text palette + semantic tokens (SS-11630)
		'ds-gray-800': '0, 0%, 35%',
		'ds-gray-900': '219, 29.5%, 20.6%',
		'text-main': '219, 29.5%, 20.6%',
		'text-additional': '0, 0%, 35%',
	},
	colorDark: {
		white: '0, 0%, 0%',
		black: '0, 0%, 100%',
		// Gray - Shades of gray
		'gray-50': '0, 0%, 9%',
		'gray-100': '0, 0%, 13%',
		'gray-200': '240, 1%, 18%',
		'gray-300': '200, 2%, 25%',
		'gray-400': '197, 4%, 32%',
		'gray-500': '200, 4%, 41%',
		'gray-600': '198, 4%, 55%',
		'gray-700': '198, 6%, 68%',
		'gray-800': '195, 4%, 78%',
		'gray-900': '0, 0%, 90%',
		// Light gray - Shades of light gray
		'light-gray-50': '195, 19%, 8%',
		'light-gray-100': '198, 14%, 14%',
		'light-gray-200': '200, 12%, 20%',
		'light-gray-300': '201, 12%, 27%',
		'light-gray-400': '201, 13%, 34%',
		'light-gray-500': '201, 13%, 43%',
		'light-gray-600': '200, 15%, 54%',
		'light-gray-700': '197, 16%, 61%',
		'light-gray-800': '199, 23%, 75%',
		'light-gray-900': '201, 15%, 82%',
		// Blue / Primary - Primary blue (500) and other shodes
		'blue-50': '211, 32%, 15%',
		'blue-100': '213, 43%, 21%',
		'blue-200': '213, 60%, 26%',
		'blue-300': '211, 78%, 32%',
		'blue-400': '211, 78%, 42%',
		'blue-500': '211, 88%, 53%',
		'blue-600': '211, 88%, 62%',
		'blue-700': '211, 88%, 72%',
		'blue-800': '211, 88%, 81%',
		'blue-900': '211, 94%, 88%',
		// Green / Success - Shades of green, used mostly for success
		'green-50': '161, 32%, 15%',
		'green-100': '161, 42%, 20%',
		'green-200': '161, 54%, 27%',
		'green-300': '160, 79%, 31%',
		'green-400': '160, 79%, 41%',
		'green-500': '161, 79%, 46%',
		'green-600': '161, 67%, 57%',
		'green-700': '161, 67%, 68%',
		'green-800': '161, 67%, 78%',
		'green-900': '161, 61%, 87%',
		// Purple - Shades of purple, used mostly for instalments
		'purple-50': '233, 32%, 15%',
		'purple-100': '233, 32%, 22%',
		'purple-200': '233, 33%, 31%',
		'purple-300': '234, 32%, 39%',
		'purple-400': '233, 33%, 47%',
		'purple-500': '234, 41%, 56%',
		'purple-600': '234, 44%, 62%',
		'purple-700': '233, 46%, 69%',
		'purple-800': '235, 42%, 79%',
		'purple-900': '234, 80%, 90%',
		// Orange / Warning - Shades of orange, used mostly for warnings and investments
		'orange-50': '33, 40%, 14%',
		'orange-100': '33, 42%, 20%',
		'orange-200': '34, 61%, 25%',
		'orange-300': '34, 76%, 34%',
		'orange-400': '34, 92%, 42%',
		'orange-500': '34, 100%, 52%',
		'orange-600': '34, 100%, 62%',
		'orange-700': '34, 100%, 71%',
		'orange-800': '34, 100%, 81%',
		'orange-900': '34, 100%, 90%',
		// Red / Error - Shades of red, used mostly for errors, destructive actions and really important highlights.
		'red-50': '358, 33%, 14%',
		'red-100': '359, 42%, 20%',
		'red-200': '358, 50%, 27%',
		'red-300': '358, 56%, 36%',
		'red-400': '357, 63%, 46%',
		'red-500': '357, 88%, 58%',
		'red-600': '357, 88%, 64%',
		'red-700': '358, 88%, 73%',
		'red-800': '358, 86%, 83%',
		'red-900': '356, 100%, 91%',
		// Design system (ds) text palette + semantic tokens (SS-11630)
		'ds-gray-800': '205, 11%, 78%',
		'ds-gray-900': '216, 12%, 92%',
		'text-main': '216, 12%, 92%',
		'text-additional': '205, 11%, 78%',
	},
	time: {
		fast: '0.1s',
		'mid-fast': '0.175s',
		control: '0.3s',
		spinner: '1s',
		black: '0, 0%, 0%',
	},
	z: {
		'order-1': 15,
		'order-2': 30,
		'order-3': 45,
		'order-4': 60,
		sticky: 200,
		modal: 300,
		notification: 400,
		fixed: 10100,
		overFixed: 99999999,
		top: 21474836471,
	},
	shadow: {
		box: '0px -4px 8px hsl(213deg 29% 33% / 10%);',
		default: '0px 4px 8px 0px hsl(200deg 17.91% 26.27% / 10%)',
		base: '0px 4px 8px 0px hsla(200, 18%, 26%, 0.1)',
	},
	fontSize: {
		content: '16px',
		base: '14px',
		xs: '12px',
		sm: '13px',
		'md-smaller': '18px',
		md: '20px',
		'md-larger': '24px',
		lg: '28px',
		'lg-larger': '36px',
		xl: '38px',
		xlg: '45px',
	},
	fontWeight: {
		thin: 400,
		base: 500,
		strong: 600,
		bold: 700,
	},
	transition: {
		base: '250ms ease',
		slower: '400ms ease',
		faster: '125ms ease',
	},
};

export function color(
	key: keyof (typeof definitions)['colorLight'],
	theme: 'dark' | 'light' = 'light',
	opacity?: number
): string {
	const def = theme === 'light' ? definitions.colorLight[key] : definitions.colorDark[key];

	if (opacity == null || opacity >= 1) {
		return `hsl(${def})`;
	}

	return `hsla(${def}, ${opacity})`;
}

export function zIndex(key: keyof (typeof definitions)['z']): number {
	return definitions.z[key];
}

export function time(
	key: keyof (typeof definitions)['time'],
	withoutUnits?: boolean
): string | number {
	const def = definitions.time[key];

	if (withoutUnits) {
		return parseFloat(def);
	}

	return def;
}

export function radius(key: keyof (typeof definitions)['radius']): string {
	return definitions.radius[key];
}

export function shadow(key: keyof (typeof definitions)['shadow']): string {
	return definitions.shadow[key];
}

export function fontSize(key: keyof (typeof definitions)['fontSize']): string {
	return definitions.fontSize[key];
}

export function fontWeight(key: keyof (typeof definitions)['fontWeight']): number {
	return definitions.fontWeight[key];
}

export function transition(key: keyof (typeof definitions)['transition']): string {
	return definitions.transition[key];
}
